const API_ENDPOINTS = {
  getAddressURL: '/offer_gfseext/customer'
};

export const selectEnvironment = () => {
  return API_ENDPOINTS;
};
